import { appIsLive, isPageB2C } from "../gtm/GtmUtils";
import { DataSyncLibEventNames } from "../shared/DataSyncLibEventNames";
import { Logger } from "../utils/Logger";

export default function addBlueConicScript(blueConicProductionHostName: string, productionHostNames: string[]): void {
  const lockName = "blueConicLoad";
  if (typeof blueConicClient !== "undefined") {
    Logger.warn("BlueConicClient already loaded");
    return;
  }
  if (isPageB2C()) {
    Logger.verbose("B2C page detected. Skipping BlueConic script load.");
    return;
  }
  let bcHostname = "cbcrc.sb.blueconic.net"; // Sandbox address
  if (appIsLive(productionHostNames)) {
    bcHostname = blueConicProductionHostName;
  }

  if (navigator.locks === undefined) {
    Logger.warn("Locks API not supported. Adding script to the page. This may cause issues.");
    void addScriptAndWaitForLoad(bcHostname);
    return;
  }

  navigator.locks
    .request(lockName, async () => {
      await addScriptAndWaitForLoad(bcHostname);
    })
    .then(() => {
      Logger.verbose("BlueConic script loaded and profile initialized.");
    })
    .catch((error) => {
      Logger.error(`Failed to load BlueConic script. Error: ${error}`);
    });
}

function addScriptAndWaitForLoad(bcHostName: string): Promise<void> {
  Logger.verbose("Adding script to the page.");
  const bcScript = document.createElement("script");
  bcScript.defer = true;
  bcScript.src = `https://${bcHostName}/script.js`;
  (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(bcScript);
  return new Promise((resolve) => {
    window.addEventListener(DataSyncLibEventNames.CdpProfileSetup, () => {
      resolve();
    });
  });
}
